import _Divider from "@arco-design/web-react/es/Divider";
import _Space from "@arco-design/web-react/es/Space";
import React from 'react';
import style from './style.less';
import { NavLink } from 'react-router-dom';
import ArcoNav from '@arco-materials/site-navbar-new';
import DesignLabSvg from '@src/assets/svg/design-lab.svg';
import useLocale from '@src/hooks/useLocale';
var Nav = function Nav() {
  var _a;
  var _b = useLocale(),
    t = _b.t,
    setLang = _b.setLang,
    lang = _b.lang;
  return /*#__PURE__*/React.createElement(ArcoNav, {
    className: style['design-lab-header'],
    hideSearch: true,
    user: ((_a = window.__user__) === null || _a === void 0 ? void 0 : _a.username) ? window.__user__ : undefined,
    loginHref: "/common/login?redirectUrl=" + location.href,
    logoutHref: "/themes/logout?redirectUrl=" + location.href,
    logo: /*#__PURE__*/React.createElement(DesignLabSvg, {
      style: {
        height: 36,
        width: 157
      }
    }),
    logoHref: "/themes",
    joinChatId: "6939713693999448066",
    lang: lang,
    onChangeLanguage: function onChangeLanguage(val) {
      setLang && setLang(val);
    },
    renderNavTabs: function renderNavTabs(dom) {
      var _a;
      return /*#__PURE__*/React.createElement("div", {
        className: style.navtabs
      }, /*#__PURE__*/React.createElement(_Space, {
        size: 14,
        align: "center",
        className: style.menu
      }, /*#__PURE__*/React.createElement(NavLink, {
        exact: true,
        to: "/home",
        onClick: function onClick(e) {
          e.preventDefault();
          location.href = '/themes/home';
        },
        activeClassName: "link-active"
      }, t['nav.tabs.home']), /*#__PURE__*/React.createElement(NavLink, {
        exact: true,
        to: "/",
        activeClassName: "link-active"
      }, t['nav.tabs.themeStore']), ((_a = window.__user__) === null || _a === void 0 ? void 0 : _a.username) ? /*#__PURE__*/React.createElement(NavLink, {
        to: "/stores/manage",
        activeClassName: "link-active"
      }, t['nav.tabs.myTheme']) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(NavLink, {
        className: style['nav-item'],
        to: "/notice",
        activeClassName: "link-active"
      }, t['nav.tabs.changelog']), /*#__PURE__*/React.createElement(_Divider, {
        type: "vertical",
        style: {
          margin: '0 4px 0 16px'
        }
      }), dom));
    }
  });
};
export default Nav;